import * as React from 'react';
import { Flex, Stack, Box, Text, Input, Checkbox, Button } from '@chakra-ui/react';
import { useEffect, useState, useMemo } from 'react';

import FigmaListTreeIcon from 'components/Icons/FigmaListTreeIcon';
import FigmaSearchIcon from 'components/Icons/FigmaSearchIcon';

interface Properties {
  handleClose: any;
  handleApply: any;
  clearButton?: any;
  checkboxData?: any;
  isMenuOpen?: any;
  filterItem?: any;
}

const PreviewSelectCheckBox = ({
  handleClose,
  handleApply,
  clearButton,
  checkboxData,
  isMenuOpen,
  filterItem,
}: Properties) => {
  const [searchValue, setSearchValue]: any = useState('');
  const [ischeckedItemsChecked, setCheckedItemsChecked] = useState<any>();
  const getFilteredResult = (mainData: any, filterData: any) => {
    const mainDimensionItems = mainData?.dimension[0]?.indicator_dimension_items || [];
    const filterDimensionItems = filterData[0]?.dimensionItems;
    return (
      mainDimensionItems.length > 0 &&
      mainDimensionItems &&
      mainDimensionItems?.map((item: any) => {
        const isInFilter = filterDimensionItems?.some(
          (filterItemData: any) =>
            filterItemData?.dimensionItemId === item?.indicator_dimension_item_id,
        );
        return {
          dimension_item_id: item?.indicator_dimension_item_id,
          name: item?.indicator_dimension_item_name,
          status: isInFilter,
          search: true,
        };
      })
    );
  };
  const result = useMemo(
    () => getFilteredResult(checkboxData, filterItem),
    [checkboxData, filterItem, isMenuOpen],
  );
  useEffect(() => {
    if (result) {
      setCheckedItemsChecked(result);
    }
  }, [result, isMenuOpen]);
  const allChecked =
    ischeckedItemsChecked && ischeckedItemsChecked?.every((item: any) => item.status);
  const isIndeterminate =
    ischeckedItemsChecked && ischeckedItemsChecked?.some((item: any) => item.status) && !allChecked;
  useEffect(() => {
    if (!isMenuOpen && searchValue) {
      setSearchValue('');
    }
  }, [isMenuOpen]);

  useEffect(() => {
    if (clearButton) {
      setCheckedItemsChecked(
        checkboxData?.dimension_items?.map((item: any) => {
          return { name: item?.dimension_item_name, status: false, search: true };
        }),
      );
    }
  }, [clearButton]);

  useEffect(() => {
    if (searchValue) {
      const searchTerm = searchValue.toLowerCase();
      const updatedItems = ischeckedItemsChecked?.map((item: any) => ({
        ...item,
        search: item.name.toLowerCase().includes(searchTerm),
      }));
      setCheckedItemsChecked(updatedItems);
    } else {
      const updatedItems = ischeckedItemsChecked?.map((item: any) => ({
        ...item,
        search: true,
      }));
      setCheckedItemsChecked(updatedItems);
    }
  }, [searchValue]);

  const handleCheckBoxChange = (user: any, event: any) => {
    const find = ischeckedItemsChecked.findIndex((item: any) => item.name === user);
    setCheckedItemsChecked((previousState: any) => {
      const newState = [...previousState];
      newState[find].status = event.target.checked;
      return newState;
    });
  };
  const handleSelectAllChekbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedItemsChecked((previousState: any) => {
      const newState = previousState?.map((item: any) => {
        return {
          ...item,
          status: event.target.checked,
        };
      });
      return newState;
    });
  };

  const handleApplyFilter = () => {
    handleApply(ischeckedItemsChecked);
  };
  const handleCloseMenu = () => {
    handleClose();
  };
  return (
    <Stack minW={'220px'} maxW={'220px'} position={'relative'} spacing={0}>
      <Box position={'sticky'} top={'0'} backgroundColor={'white'} zIndex={1} pb='4px'>
        <Flex alignItems='center' gap='8px'>
          <FigmaListTreeIcon width={14} height={14} color='#8B5CF6' />
          <Text
            fontFamily='Roboto Medium, Roboto Regular'
            fontWeight='600'
            fontSize='13px'
            color='#121826'
          >
            {checkboxData?.dimension_name}
          </Text>
        </Flex>
        {ischeckedItemsChecked?.length > 0 && (
          <Flex
            alignItems='center'
            gap='8px'
            bg='white'
            border='1px solid #D1D6DD'
            borderRadius='8px'
            px='10px'
            height='32px'
            my='10px'
            transition='border-color 0.12s ease'
            _focusWithin={{ borderColor: '#C4B5FD' }}
          >
            <FigmaSearchIcon width={13} height={13} color='#708090' />
            <Input
              variant='unstyled'
              placeholder='Search'
              fontSize='13px'
              fontFamily='Roboto Regular'
              color='#121826'
              _placeholder={{ color: '#708090' }}
              value={searchValue}
              onChange={(event: any) => setSearchValue(event.target.value)}
            />
          </Flex>
        )}
        <Checkbox
          isChecked={allChecked}
          isIndeterminate={isIndeterminate}
          onChange={handleSelectAllChekbox}
          colorScheme='purple'
          size='sm'
        >
          <Text fontSize='12px' fontFamily='Roboto Regular' color='#121826'>
            Select All
          </Text>
        </Checkbox>
      </Box>
      {ischeckedItemsChecked?.length > 0 ? (
        <>
          <Stack
            maxH={'160px'}
            overflowY={'auto'}
            className={'filters_scroll'}
            spacing='6px'
            py='6px'
          >
            {ischeckedItemsChecked?.map((user: any, index: number) => (
              <React.Fragment key={index}>
                {user?.search && (
                  <Checkbox
                    pl='6px'
                    colorScheme='purple'
                    size='sm'
                    isChecked={ischeckedItemsChecked[index]?.status}
                    onChange={(event) => {
                      handleCheckBoxChange(user?.name, event);
                    }}
                  >
                    <Text
                      maxW={'130px'}
                      className='text-overflow'
                      fontSize='12px'
                      fontFamily='Roboto Regular'
                      color='#121826'
                      title={user?.name}
                    >
                      {user?.name}
                    </Text>
                  </Checkbox>
                )}
              </React.Fragment>
            ))}
          </Stack>
          <Flex justifyContent={'flex-end'} gap='8px' mt='10px'>
            <Button
              onClick={handleCloseMenu}
              size='sm'
              h='30px'
              px='12px'
              bg='white'
              border='1px solid #D1D6DD'
              borderRadius='8px'
              fontFamily='Roboto Regular'
              fontWeight='500'
              fontSize='12px'
              color='#121826'
              _hover={{ bg: 'gray.50' }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleApplyFilter}
              disabled={!isIndeterminate && !allChecked}
              size='sm'
              h='30px'
              px='12px'
              bg='#8B5CF6'
              borderRadius='8px'
              fontFamily='Roboto Regular'
              fontWeight='500'
              fontSize='12px'
              color='white'
              _hover={{ bg: '#7C4DEF' }}
              _disabled={{ bg: '#D6BBFB', cursor: 'not-allowed' }}
            >
              Apply
            </Button>
          </Flex>
        </>
      ) : (
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignContent={'center'}
          py='12px'
        >
          <Text fontSize='12px' fontFamily='Roboto Regular' color='#708090'>
            No Dimension items
          </Text>
        </Box>
      )}
    </Stack>
  );
};

export default PreviewSelectCheckBox;
